/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import 'swiper/css/swiper.css';
// import 'fullpage-vue/src/fullpage.css';
// import 'swiper/css/swiper.css';

// import VueFullpage from 'fullpage-vue'
// 引入i18n配置
import i18n from './i18n/i18n';

Vue.config.productionTip = false;
Vue.use(Argon);
// Vue.use(Swiper);
new Vue({
  router,
  i18n,
  render: h => h(App),
  mounted() {
    // 页面加载时，跳转到上次访问的路由
    // const lastRoute = localStorage.getItem('lastRoute');
    // if (lastRoute && lastRoute !== this.$route.fullPath) {
    //   this.$router.push(lastRoute);
    // }
  }
}).$mount("#app");
